var r = function r(_r, o) {
  try {
    1 == arguments.length ? console.error(_r) : console.error(_r, o);
  } catch (r) {}
};
export { r as h };